import { render, staticRenderFns } from "./ForwardMessageActionsWarning.vue?vue&type=template&id=d699252e&scoped=true&"
import script from "./ForwardMessageActionsWarning.vue?vue&type=script&lang=js&"
export * from "./ForwardMessageActionsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d699252e",
  null
  
)

export default component.exports